import { render, staticRenderFns } from "./inputtext.vue?vue&type=template&id=492b4d73&"
import script from "./inputtext.vue?vue&type=script&lang=js&"
export * from "./inputtext.vue?vue&type=script&lang=js&"
import style0 from "./inputtext.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports